import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GenericAddressCardStackBackgroundViewModel } from './generic-address-card-stack-background-view-model';
import type { GenericCardData } from '../../../../../../../models/print-cards/generic-card-data';

@Component({
  selector: 'app-generic-address-card-stack-background',
  templateUrl: './generic-address-card-stack-background.component.html',
  styleUrls: ['./generic-address-card-stack-background.component.scss'],
  providers: [GenericAddressCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericAddressCardStackBackgroundComponent extends CardBackgroundComponent implements AfterViewInit {
  constructor(
    public viewModel: GenericAddressCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GenericCardData;
}
